import { jsxs as F, jsx as c } from "react/jsx-runtime";
import * as S from "react";
import { forwardRef as E, useState as k, useMemo as O, useEffect as P } from "react";
import { I as W } from "./ic_add-CT2XM2pO.mjs";
import { c as q } from "./index.js-Cr0Rsuyz.mjs";
import { c as j } from "./variance-DhhqoHkK.mjs";
import { T as G } from "./text-field-CPUJ0YL4.mjs";
import { c as C } from "./tw-cn-mXgPecoF.mjs";
function H(f, b) {
  return /* @__PURE__ */ S.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: b
  }, f), /* @__PURE__ */ S.createElement("path", {
    fill: "currentColor",
    d: "M4 12.75a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 0 1.5z"
  }));
}
var J = q(/* @__PURE__ */ E(H));
const K = j("flex w-fit shrink-0 items-center bg-fill-neutral-weak rounded-16 overflow-hidden"), B = j(
  [
    "flex min-h-48 shrink-0 items-center justify-center py-4",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak [&>*]:disabled:!text-interaction-neutral-disable-main",
    "disabled:hover-never:bg-fill-neutral-weak "
  ],
  {
    variants: {
      type: {
        minus: "pl-12 pr-6",
        plus: "pl-6 pr-12 "
      }
    }
  }
), L = E((f, b) => {
  const {
    id: g,
    defaultValue: V = "",
    value: n,
    min: r = 0,
    max: i = 999,
    disabled: u = !1,
    className: M,
    onChange: a,
    onInvalidRange: s
  } = f, h = g ? `${g}-` : "", [T, m] = k(`${V}`), [_, w] = k(!1), [z, v] = k(!1), l = n !== void 0, p = l ? `${n}` : T, x = Number(p) <= r || u, N = Number(p) >= i || u, d = O(() => l ? n : V, []), I = (e) => {
    if (e === "")
      return !1;
    const t = Number(e);
    return Number.isInteger(t);
  }, y = (e) => {
    let t = e;
    return e < r ? (s == null || s(e), t = r, l ? a == null || a(r) : m(`${r}`)) : e > i ? (s == null || s(i), t = i, l ? a == null || a(i) : m(`${i}`)) : l ? a == null || a(e) : m(`${e}`), t;
  }, $ = (e) => {
    const t = Number(p || r) + e, o = y(t);
    v(o !== Number(d));
  }, D = (e) => {
    const t = e.target.value;
    if (w(!1), t === "") {
      s == null || s(""), w(!0), l ? a == null || a(r) : m(`${r}`);
      return;
    }
    I(t) && y(Number(t));
  }, A = (e) => {
    const t = e.target.value;
    let o;
    I(t) ? o = Number(t) : (w(!1), o = y(r)), v(o !== Number(d));
  };
  return P(() => {
    l && v(n !== Number(d));
  }, [n, d, l]), /* @__PURE__ */ F("div", { className: C(K(), M), children: [
    /* @__PURE__ */ c(
      "button",
      {
        "aria-disabled": x || void 0,
        "aria-label": "마이너스 버튼",
        className: B({ type: "minus" }),
        disabled: x,
        id: `${h}stepper-minus`,
        onClick: () => {
          $(-1);
        },
        tabIndex: x ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ c(J, { className: "size-20 text-text-neutral-main" })
      }
    ),
    /* @__PURE__ */ c(
      G,
      {
        "aria-disabled": u || void 0,
        "aria-label": "숫자 입력",
        className: "w-fit",
        disabled: u,
        id: `${h}stepper-input`,
        inputClassName: C(
          "text-center !font-bold transition-colors focus:!typography-subtitle-18-semibold",
          "autofill:!bg-fill-neutral-weak autofill:shadow-[inset_0_0_0_1000px] autofill:shadow-fill-neutral-weak",
          z ? "!typography-subtitle-18-semibold text-text-primary-main" : "!typography-subtitle-18-regular text-text-neutral-main"
        ),
        inputMode: "numeric",
        inputWrapperClassName: "!p-4 rounded-none min-h-48 pc:min-h-48 w-40 min-w-40 !border-none bg-fill-neutral-weak [&>*]:bg-fill-neutral-weak",
        max: i,
        min: r,
        onBlur: A,
        onChange: D,
        ref: b,
        tabIndex: u ? -1 : 0,
        type: "number",
        value: _ ? "" : p
      }
    ),
    /* @__PURE__ */ c(
      "button",
      {
        "aria-disabled": N || void 0,
        "aria-label": "플러스 버튼",
        className: B({ type: "plus" }),
        disabled: N,
        id: `${h}stepper-plus`,
        onClick: () => {
          $(1);
        },
        tabIndex: N ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ c(W, { className: "size-20 text-text-neutral-main" })
      }
    )
  ] });
});
L.displayName = "NDS.Stepper";
export {
  L as S
};
